module.exports = __webpack_public_path__ + "media/images/lb/509-d1c5b5f7209f3e73273eebd429b4546f.svg";